import React, {useEffect, useState, useContext} from 'react';
import Breadcrumb from '../../shared/Breadcrumb';
import SideNav from '../shared/SideNav';
import axios from 'axios';
import { AuthContext } from '../../../contexts/AuthContext';
import DashboardTabs from '../../shared/DashboardTabs';
import { apiRoutes } from '../../../AppSettings';
import Util from '../../../Util';
import alertify from "alertifyjs";
import { trackPromise } from 'react-promise-tracker';

const PatientDashboard = (props) => {
    const { userState } = useContext(AuthContext);
    const [patient, setPatient] = useState(userState.loggedInUser);
    const [appoinments, setAppoinments] = useState([]); 

    console.log(userState.loggedInUser);
    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
      };

    const updateAppoinments = (data) => {
        setAppoinments(data);
    }

    useEffect(() => {
        trackPromise(
            axios.get(apiRoutes.getAppoinmentsByPatient + patient.patientId, options)
            .then((response) => {
            if(response.status === 200)
            {
                const data = response.data;
                console.log(data);
                updateAppoinments(data.data);
            }
            }, (error) => {
            console.log(error);
            alertify.error(Util.getErrorMessages(error.response.data.errorMessages));
            })
        );
    }, []);

    return (
        <div>
            <Breadcrumb title="Dashboard" />
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <SideNav applyCssFor='dashboard' user={patient} />
                        </div>
                        <div className="col-md-7 col-lg-8 col-xl-9">
                            <DashboardTabs PatientId = {patient.patientId} userType={userState.userType} Details = {{Appoinments: appoinments}}  />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PatientDashboard;